import { Component, OnInit } from "@angular/core";
import { Subscription } from "rxjs/Subscription";
import { ReceiptDialogComponent } from "../receipt-dialog/receipt-dialog.component";
import { MatDialog } from "@angular/material";
import * as moment from "moment";
import { Angular2Csv } from "angular2-csv/Angular2-csv";
import { BASE64_LOGO } from "../../shared/pdf-logo-base64";
declare var pdfMake: any;
import { MdDialogFix } from "../md-dialog-fix";

import {
  AuthGuardService,
  LoadingService,
  UserService,
  DialogService,
} from "@core/services";
import { User, Payment } from "@shared/models";

import { ResultDialogComponent } from "../result-dialog/result-dialog.component";

import { fadeAnimation } from "../../app.animations";
import { RefundDialogComponent } from "../refund-dialog/refund-dialog.component";

@Component({
  selector: "app-payment-history",
  templateUrl: "./payment-history.component.html",
  styleUrls: ["./payment-history.component.css"],
  animations: [fadeAnimation],
})
export class PaymentHistoryComponent implements OnInit {
  user: User;
  subscription: Subscription;

  public startDate: any;
  public endDate: any;
  public isLoadingPaymentHistory: boolean;
  public isLoadingCreditHistory: boolean;

  public paymentHistory: any;
  private paymentCount: number;
  private pdf: any;

  private initialModalWidth: string = "50vw";

  constructor(
    private _userService: UserService,
    private _authGuard: AuthGuardService,
    private dialog: MatDialog,
    private _dialogService: DialogService,
    private _loadingService: LoadingService
  ) {}

  ngOnInit() {
    this.startDate = new Date();
    this.endDate = new Date();
    this.startDate.setMonth(this.startDate.getMonth() - 1);
    this.subscription = this._userService.getUser().subscribe((user) => {
      this.user = user;

      if (this.user.accountSummaryArray) {
        if (this.user.accountSummaryArray.length > 0) {
          this.isLoadingCreditHistory = true;
          this.isLoadingPaymentHistory = true;
          this.getHistory();
        }
      }
      
    });
    this.initialModalWidth = "50vw";
  }

  onChange() {
    this.getHistory();
  }

  onAccountChange(accountIndex) {
    this.getHistory();
  }

  onIssueRefund(payment) {
    //console.log("payment:", payment);
    const amount = payment.amountpaid.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
    //console.log("amount:", amount);
    //console.log("cash", parseFloat(String(payment.amountpaid)));
    // this._dialogService.confirm('Refund', 'Issue refund for the amount ' + amount + "?")
    //   .subscribe(result => {
    //     if(!result) return;
    //     this.issueVoidRefundRequest(payment, "refund");
    //   })
    const dialogRef = this.dialog.open(RefundDialogComponent, {});
    dialogRef.componentInstance.paymentId = payment.id;
    dialogRef.componentInstance.amount = parseFloat(String(payment.amountpaid));
    dialogRef.componentInstance.startDate = this.startDate;
    dialogRef.componentInstance.endDate = this.endDate;
  }

  onIssueVoid(payment) {
    const amount = payment.amountpaid.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
    this._dialogService
      .confirm("Void", "Issue void for the amount " + amount + "?")
      .subscribe((result) => {
        if (!result) return;
        this.issueVoidRefundRequest(payment, "void");
      });
  }

  private issueVoidRefundRequest(payment, type) {
    this._loadingService.showLoader();
    const url = `CustomerService/VoidRefundPayment`;
    const amount = payment.amountpaid.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
    this._authGuard
      .authenticatedPost(url, { PaymentId: payment.id, Amount: 0.0 })
      .subscribe(
        (result) => {
          let dialogRef = this.dialog.open(ResultDialogComponent, {
            data: {
              title: "Success",
              message: `Your ${type} request for the amount ${amount} was successful.`,
              alertType: "success",
            },
            width: "350px",
          });
          this.getHistory();
          this._loadingService.hideLoader();
        },
        (error) => {
          let dialogRef = this.dialog.open(ResultDialogComponent, {
            data: {
              title: "Error",
              message: `There was an error. ${error}`,
              alertType: "danger",
            },
            width: "350px",
          });
          this._loadingService.hideLoader();
        }
      );
  }

  isVoidable(payment) {
    const d1 = new Date();
    const d2 = new Date(payment.paymentdate);
    return (
      d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate()
    );
  }

  getHistory() {
    this.paymentCount = 0;
    this.getPaymentHistory();
    this.getCreditHistory();
  }

  getCreditHistory() {
    const creditHistoryUrl = "portfolios/CreditPaymentHistory";
    let creditResult: any;
    let data = this.setUpPaymentHistoryData();

    this._authGuard.authenticatedPost(creditHistoryUrl, data).subscribe(
      (result) => {
        this._userService.emptyCreditHistoryArray();
        this.isLoadingCreditHistory = false;
        creditResult = result;
        for (const credit of creditResult) {
          if (credit.cardnumber != "Account Payment") {
            this._userService.addCredit(
              credit.id,
              credit.paymentdate,
              credit.amountpaid,
              credit.cardnumber
            );
          }
        }
      },
      (error) => console.log("Error: " + error)
    );
  }

  setUpPaymentHistoryData() {
    let accountId = ""
    if(this.user.accountSummaryArray.length > 0){
      accountId = this.user.accountSummaryArray[this.user.accountIndex].id
    } else {
      accountId = this.user.customerIdArray[this.user.customerIndex].Account.Id
    }
    return {
      CustomerId: this.user.customerIdArray[this.user.customerIndex].Id,
      AccountId: accountId,
      StartDate: this.startDate,
      EndDate: this.endDate,
    };
  }

  getPaymentHistory() {
    const creditHistoryUrl = "portfolios/PaymentHistory";
    let paymentResult: any;
    let data = this.setUpPaymentHistoryData();
    if (this.user.customerIdArray[this.user.customerIndex] == undefined) {
      return;
    }
    this._authGuard.authenticatedPost(creditHistoryUrl, data).subscribe(
      (result) => {
        this._userService.emptyPaymentHistoryArray();
        this.isLoadingPaymentHistory = false;
        console.log(result);
        paymentResult = result;
        this.paymentHistory = this.buildPaymentHistory(paymentResult);
        this.paymentHistory = paymentResult;
        for (let payment of paymentResult) {
          if (payment.currency) {
            payment.currency = payment.currency == 1 ? "CAD" : "USD";
            console.log(payment.currency);
          }

          this._userService.addPayment(
            payment.id,
            payment.cardnumber,
            payment.paymentdate,
            payment.amountpaid,
            payment.authcode
          );
          this.paymentCount += 1;
        }
      },
      (error) => console.log("Error: " + error)
    );
  }

  private buildPaymentHistory(data) {
    return data.map((e) => {
      if(e.authcode != null && e.authcode != "") {
        e.reference = e.authcode.split("|")[1];
        e.auth = e.authcode.split("|")[0];
        e.status = this.extractStatus(e.authcode);
        return e;
      } else {
        e.reference = "";
        e.auth = "";
        e.status = "";
        return e;
      }
    });
  }

  private extractStatus(authcode) {
    let code = authcode.toLowerCase();
    if (code.includes("declined")) {
      return "Declined";
    } else if (code.includes("voided")) {
      return "Voided";
    } else if (code.includes("partially")) {
      var tempSplit = authcode.split("|");
      var tempStr = "";
      tempSplit.forEach((element) => {
        if (element.toString().includes("Partially")) {
          tempStr = element.toString();
          return element.toString();
        }
      });
      return tempStr;
    } else if (code.includes("refunded")) {
      return "Refunded";
    } else if (code.includes("approved")) {
      return "Approved";
    } else {
      return "N/A";
    }
  }

  viewReceipt(payment) {
    console.log(payment);
    let name = this.user.customerIdArray[this.user.customerIndex]
      .GeneralContact;
    let account = this.user.customerIdArray[this.user.customerIndex].Account.Id;
    let dialogRef = this.dialog.open(ReceiptDialogComponent, {
      data: {
        payment_dt: payment.paymentdate,
        account_id: account,
        amount: payment.amountpaid,
        currency: payment.currency,
        id: payment.id,
        username: name,
        cardNumber: payment.cardnumber,
        reference: payment.reference,
        authCode: payment.auth,
        status: payment.status,
      },
      minWidth: this.initialModalWidth,
    });
    dialogRef.afterOpen().subscribe(MdDialogFix);
  }

  setUpReceiptData(receiptId) {
    return {
      CustomerId: this.user.customerIdArray[this.user.customerIndex].Id,
      ReceiptId: receiptId,
      AccountId: this.user.accountSummaryArray[this.user.accountIndex].id,
    };
  }

  downloadTripHistoryCSV() {
    var data = new Array();
    data.push({ title: "Payment History" });
    data.push({
      col1: "Id",
      col2: "Card Number",
      col3: "Date",
      col4: "Time",
      col5: "Amount",
      col6: "Reference",
      col7: "Status",
    });

    for (let payment of this.paymentHistory) {
      let p = this.user.paymentHistoryArray.find((e) => e.id === payment.id);
      data.push({
        id: p.id,
        cardnumber: p.cardNumber,
        date: p.paymentDate,
        time: p.paymentTime,
        amount: p.amountPaid,
        reference: payment.reference,
        status: payment.status,
      });
    }
    new Angular2Csv(data, "Payment History Report");
  }

  downloadTripHistoryPDF() {
    this.pdf = pdfMake;
    var dateStartDate = new Date(this.startDate);
    var dateEndDate = new Date(this.endDate);
    var strStartDate = "Y_m_d"
      .replace("Y", String(dateStartDate.getFullYear()))
      .replace("m", String(dateStartDate.getMonth() + 1))
      .replace("d", String(dateStartDate.getDate()));
    var strEndDate = "Y_m_d"
      .replace("Y", String(dateEndDate.getFullYear()))
      .replace("m", String(dateEndDate.getMonth() + 1))
      .replace("d", String(dateEndDate.getDate()));
    this.pdf
      .createPdf(this.buildPdf())
      .download(
        "Detroit_Windsor_Tunnel-Payment_History-" +
          strStartDate +
          "-" +
          strEndDate +
          ".pdf"
      );
  }

  buildPdf() {
    const docDefinition = {
      footer: [],
      styles: {
        header: {
          fontSize: 22,
          bold: true,
        },
      },
      content: [
        {
          margin: [0, 10],
          columns: [
            {
              image: BASE64_LOGO,
              width: 128,
            },
          ],
        },
        {
          canvas: [
            {
              type: "line",
              x1: 0,
              y1: 5,
              x2: 595 - 2 * 40,
              y2: 5,
              lineWidth: 0.5,
              color: "#666666",
            },
          ],
          alignment: "center",
          margin: [0, 0, 0, 10],
        },
        { text: "Payment History", style: "header" },
        {
          table: {
            body: [
              [
                "Id",
                "Date",
                "Time",
                "Amount",
                "Card Number",
                "Reference",
                "Status",
              ],
            ],
          },
          layout: "noBorders",
          margin: [0, 20, 0, 20],
        },
        // { text:"Credit History", style: 'header', pageBreak: 'before' },
        // {
        //   table: {
        //     body: [
        //       ['Reference #', 'Date', 'Time', 'Amount', 'Type']
        //     ],
        //   },
        //   layout: 'noBorders',
        //   margin: [0, 20, 0, 20]
        //
        // },
        {
          canvas: [
            {
              type: "line",
              x1: 0,
              y1: 5,
              x2: 595 - 2 * 40,
              y2: 5,
              lineWidth: 0.5,
              color: "#666666",
            },
          ],
          alignment: "center",
          margin: [0, 20, 0, 10],
        },
        {
          text:
            "Copyright " +
            new Date().getFullYear() +
            " DWTunnel. All rights reserved.",
        },
      ],
    };

    for (let payment of this.paymentHistory) {
      let p = this.user.paymentHistoryArray.find((e) => e.id === payment.id);
      docDefinition.content[3]["table"]["body"].push([
        p.id,
        p.paymentDate,
        p.paymentTime,
        p.amountPaid,
        p.cardNumber,
        p.authCode,
        payment.status,
      ]);
    }

    return docDefinition;
  }
}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/payment-history/payment-history.component.ts